<template>
  <div class>
    <Hero />

    <section class="section">
      <div class="container">
        <div class="logo_back">
          <div
            style="z-index: 1; 
          position: relative; 
          height: 25rem; 
          background: #ffffffb0; 
          font-size: 2rem;
          padding: 3rem 0;">
            <h1 style="margin-top: 85px; font-size:50px;">Kinetica - centru de recuperare medicala și sportivă</h1>
          </div>
        </div>
      </div>
    </section>

    <section class="section services-section">
      <div class="container services-display">
        <div class="columns">
          <div class="column small-padding">
            <div class="cat sport">
              <div class="cat_overlay">
                <div class="cat_over_title">
                  <ul>
                    <li>Pasivă asistată</li>
                    <li>Corehab</li>
                    <li>Recuperare sportivă</li>
                  </ul>
                </div>
                <router-link class="cat_detail_link" to="/servicii/kinetoterapie">Detalii</router-link>
              </div>
              <div class="cat_title">
                <a href="oldies" class="cat_link">
                  Kinetoterapie
                </a>
              </div>
            </div>
          </div>

          <div class="column small-padding">
            <div class="cat fizio">
              <div class="cat_overlay">
                <div class="cat_over_title">Fizioterapie</div>
                <router-link class="cat_detail_link" to="/servicii/fizioterapie">Detalii</router-link>
              </div>
              <div class="cat_title">
                <a href="oldies" class="cat_link">Fizioterapie</a>
              </div>
            </div>
          </div>

          <div class="column small-padding">
            <div class="cat pediatrica">
              <div class="cat_overlay">
                <div class="cat_over_title">Kinetoterapie pediatrică</div>
                <router-link class="cat_detail_link" to="/servicii/kinetoterapie-pediatrica">Detalii</router-link>
              </div>
              <div class="cat_title">
                <a href="oldies" class="cat_link">Kinetoterapie pediatrică</a>
              </div>
            </div>
          </div>

          <div class="column small-padding">
            <div class="cat masaj">
              <div class="cat_overlay">
                <div class="cat_over_title">Masaj</div>
                <router-link class="cat_detail_link" to="/servicii/masaj">Detalii</router-link>
              </div>
              <div class="cat_title">
                <a href="oldies" class="cat_link">Masaj</a>
              </div>
            </div>
          </div>

          <div class="column small-padding">
            <div class="cat domiciliu">
              <div class="cat_overlay">
                <div class="cat_over_title">Recuperare la domiciliu</div>
                <router-link class="cat_detail_link" to="/servicii/recuperare-la-domiciliu">Detalii</router-link>
              </div>
              <div class="cat_title">
                <a href="oldies" class="cat_link">Recuperare la domiciliu</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="columns">
        <div class="column">
          <h3>Programări telefonice</h3>
          <p>Număr telefon: 0265 311 303</p>
          <p>Email: olikinetic@yahoo.com</p>
        </div>
      </div>
    </section>
  </div>
</template> 

<script>
// @ is an alias to /src
import Hero from "@/components/Hero.vue";

export default {
  name: "Home",
  components: {
    Hero,
  },
};
</script>

<style>
.logo_back {
  background-image: url("../assets/logo_k.webp");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100%;
  /* position: absolute; */
  width: 100%;
}

.cat {
  background-position-x: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 30rem;
  flex: 1 1 auto;
  margin: 0 0.2rem;
  position: relative;
}

.sport {
  background-image: url("../assets/JOC_3727.webp");
  background-position-x: -70px;
}

.fizio {
  background-image: url("../assets/JOC_2923.webp");
  background-position-y: bottom;
}

.pediatrica {
  background-image: url("../assets/JOC_3175.webp");
}

.masaj {
  background-image: url("../assets/JOC_3674.webp");
  background-position-x: -160px;
}

.domiciliu {
  background-image: url("../assets/JOC_3561.webp");
  background-position-x: -80px;
}

.cat_overlay {
  align-items: center;
  background-color: #000a;
  /*	display: flex;*/
  display: none;
  flex-flow: column;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
}
.cat:hover .cat_overlay {
  display: flex;
}
.cat_title {
  align-items: center;
  background-color: #ffffffc0;
  bottom: 0;
  display: flex;
  font-weight: bold;
  height: 4rem;
  justify-content: center;
  padding: 0.5rem;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.cat:hover .cat_title {
  display: none;
}
.cat_link {
  color: #333;
}
.cat_link:hover {
  color: #00bbd4;
}
.cat_over_title {
  color: #fff;
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: -5rem;
  padding: 0 0.5rem;
  text-align: center;
}
.cat_detail_link,
.cat_detail_link:visited,
.cat_detail_link:active {
  border: 2px solid #fff;
  border-radius: 0.4rem;
  bottom: 9rem;
  color: #fff;
  display: inline-block;
  padding: 0.8rem 1rem;
  position: absolute;
}
.cat_detail_link:hover {
  border: 2px solid #00bbd4;
  color: #00bbd4;
}
.maps {
  width: 1600px;
}
.small-padding {
  padding: 0 !important;
}
.services-display {
  max-width: 1600px !important;
}
.services-section {
  padding-top: 10px !important;
}
.hero.is-primary {
  background-color: white;
}
</style>
